import { render } from "./AiAssistant.vue?vue&type=template&id=562e9284"
import script from "./AiAssistant.vue?vue&type=script&lang=js"
export * from "./AiAssistant.vue?vue&type=script&lang=js"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__